import React from "react";
import TooltipIcon from "../Tooltip/TooltipIcon";
import { TrendingUpIcon, TrendingDownIcon } from "../Icons/SvgIcon";

const KPICard = ({ label, tooltipTitle, value, changePercent, changeType = "negative", prevValue, compareYear }) => {
  const isPositive = changeType === "positive";

  const formatNumber = (num) => {
    if (typeof num === 'number') {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: num % 1 !== 0 ? 2 : 0,
        maximumFractionDigits: 2,
      });
    }
    return num;
  };

  return (
    <div className="analytics-kpi-card">
      <div className="analytics-kpi-card__header">
        <span className="analytics-kpi-card__label">{label}</span>
        <TooltipIcon title={tooltipTitle} />
      </div>
      <div className="analytics-kpi-card__value-section">
        <div className="analytics-kpi-card__value">{formatNumber(value)}</div>
        <div className={`analytics-kpi-card__change analytics-kpi-card__change--${changeType}`}>
          {isPositive ? (
            <TrendingUpIcon width="14" height="14" />
          ) : (
            <TrendingDownIcon width="14" height="14" />
          )}{" "}
          {changePercent}
        </div>
      </div>
      {prevValue !== undefined && prevValue !== null && compareYear && (
        <div className="analytics-kpi-card__comparison">
          {formatNumber(prevValue)} in {compareYear}
        </div>
      )}
    </div>
  );
};

export default KPICard;
